const ALL = "*";

export const ROLE_PERMISSIONS = {
  root: [ALL],
  // Legacy admin permissions. Full current-admin access belongs to new_admin.
  admin: [
    // Exact legacy allowAdmin surface from shift-app-server.
    "drivers.*", "shifts.*", "payments.view", "payments.enter", "payments.release", "payments.approve",
    "hubs.*", "metros.*",
  ],
  new_admin: [ALL],
  bookkeeper: ["payments.view", "payments.enter", "payments.approve", "payments.release"],
  metro_manager: ["drivers.*", "shifts.*"],
  area_manager: ["drivers.view", "drivers.email", "drivers.phone", "drivers.bulk_status", "drivers.fields", "shifts.view", "shifts.create", "shifts.update", "shifts.reserve", "shifts.assign", "shifts.complete", "shifts.approve", "shifts.approve_exception", "shifts.cancel", "shifts.reject", "payments.view", "payments.enter", "bonus.create", "bonus.reports", "bonus.disburse", "hubs.view", "hubs.manage", "metros.view", "metros.manage"],
  sr_hub_manager: ["drivers.view", "drivers.email", "drivers.phone", "drivers.bulk_status", "drivers.fields", "shifts.view", "shifts.create", "shifts.update", "shifts.reserve", "shifts.assign", "shifts.complete", "shifts.approve", "shifts.approve_exception", "shifts.cancel", "shifts.reject", "payments.view", "payments.enter", "bonus.create", "bonus.reports", "bonus.disburse", "hubs.view", "metros.view"],
  hub_manager: ["drivers.view", "drivers.email", "drivers.phone", "drivers.bulk_status", "drivers.fields", "shifts.view", "shifts.schedule", "shifts.create", "shifts.update", "shifts.reserve", "shifts.assign", "shifts.complete", "shifts.approve", "shifts.approve_exception", "shifts.cancel", "shifts.reject", "payments.view", "payments.enter", "payments.calendar", "bonus.reports", "hubs.view", "metros.view"],
  driver_compliance: ["drivers.view", "drivers.email", "drivers.delete_ssn", "drivers.phone", "drivers.bulk_status", "drivers.fields", "drivers.payment_status", "shifts.view", "shifts.create", "shifts.update", "shifts.reserve", "shifts.assign", "shifts.complete", "shifts.cancel", "shifts.reject", "payments.view", "payments.enter", "bonus.create", "bonus.reports", "bonus.disburse", "hubs.view", "hubs.manage", "metros.view", "metros.manage"],
  hub_lead: ["drivers.view", "drivers.email", "drivers.phone", "drivers.bulk_status", "drivers.fields", "shifts.view", "shifts.schedule", "shifts.create", "shifts.update", "shifts.reserve", "shifts.assign", "shifts.cancel", "shifts.reject", "payments.view", "bonus.reports", "hubs.view", "metros.view"],
  dispatcher: ["drivers.view", "drivers.email", "drivers.phone", "drivers.fields", "shifts.view", "shifts.schedule", "shifts.create", "shifts.update", "shifts.reserve", "shifts.assign", "shifts.cancel", "shifts.reject", "payments.view", "bonus.reports", "hubs.view", "metros.view"],
  finance_payments: ["drivers.view", "drivers.email", "drivers.phone", "drivers.fields", "drivers.payment_status", "shifts.view", "shifts.complete", "shifts.approve", "shifts.approve_exception", "payments.view", "payments.release", "payments.enter", "payments.approve", "payments.calendar", "bonus.create", "bonus.reports", "bonus.disburse", "hubs.view", "metros.view"],
  regional_manager: [],
  supervisor: ["drivers.view", "drivers.email", "drivers.delete_ssn", "drivers.phone", "drivers.bulk_status", "drivers.fields", "shifts.view", "shifts.schedule", "shifts.create", "shifts.update", "shifts.reserve", "shifts.assign", "shifts.complete", "shifts.approve", "shifts.approve_exception", "shifts.cancel", "shifts.reject"],
};

export const checkPermission = (role, permission) => {
  const permissions = ROLE_PERMISSIONS[role] || [];
  return permissions.includes(ALL) || permissions.includes(permission) ||
    permissions.some((item) => item.endsWith(".*") && permission.startsWith(item.slice(0, -1)));
};

export const canAny = (role, permissions) => permissions.some((permission) => checkPermission(role, permission));

const OPERATIONAL_ASSIGNABLE_ROLES = [
  "area_manager",
  "sr_hub_manager",
  "hub_manager",
  "driver_compliance",
  "hub_lead",
  "dispatcher",
  "finance_payments",
  "regional_manager",
  "supervisor",
];

export const canAssignRole = (actorRole, targetRole) => {
  if (actorRole === "root") return Object.hasOwn(ROLE_PERMISSIONS, targetRole);
  if (actorRole === "new_admin") {
    return targetRole !== "root" && Object.hasOwn(ROLE_PERMISSIONS, targetRole);
  }
  return checkPermission(actorRole, "users.create") &&
    OPERATIONAL_ASSIGNABLE_ROLES.includes(targetRole);
};

export const FINALIZED_PAYMENT_UPDATE_ROLES = [
  "root",
  "admin",
  "area_manager",
  "sr_hub_manager",
  "hub_manager",
];

export const canUpdateFinalizedPayment = (role) =>
  FINALIZED_PAYMENT_UPDATE_ROLES.includes(role);
